var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSetupRightCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 90,
    viewBox: "0 0 117 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6017_2202",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 135,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9337 60.1167C29.4046 60.133 28.9731 59.7026 28.9731 59.1736V30.5019C28.9731 29.9732 29.4023 29.5441 29.9316 29.5441H58.6223C59.1516 29.5441 59.5823 29.9751 59.566 30.5038C59.0684 46.6341 46.0744 59.6195 29.9337 60.1167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2148 60.1167C89.7439 60.133 90.1753 59.7026 90.1753 59.1736V30.5019C90.1753 29.9732 89.7462 29.5441 89.2168 29.5441H60.5262C59.9969 29.5441 59.5662 29.9751 59.5825 30.5038C60.0801 46.6341 73.0741 59.6195 89.2148 60.1167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3616 1.19066C46.0265 0.301029 44.5522 0.301029 44.2172 1.19066C43.2455 3.77389 41.6535 7.29785 39.6075 9.34385C37.5616 11.3898 34.0374 12.982 31.4548 13.9535C30.5646 14.2887 30.5646 15.7629 31.4548 16.098C34.0374 17.0695 37.5616 18.6617 39.6075 20.7077C41.6535 22.7537 43.2455 26.2776 44.2172 28.8601C44.5522 29.7505 46.0265 29.7505 46.3616 28.8601C47.3332 26.2776 48.9253 22.7537 50.9713 20.7077C53.0173 18.6617 56.5413 17.0695 59.1245 16.098C60.0142 15.7629 60.0142 14.2887 59.1245 13.9535C56.5413 12.982 53.0173 11.3898 50.9713 9.34385C48.9253 7.29785 47.3332 3.77389 46.3616 1.19066Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.107 -4.83887e-08C0.484563 -2.11809e-08 -0.0222394 0.506429 0.000752697 1.12857C0.58044 16.8301 13.2048 29.4547 28.9064 30.034C29.5284 30.0573 30.035 29.5501 30.035 28.928L30.035 1.12706C30.035 0.504924 29.5304 -1.29081e-06 28.9079 -1.26361e-06L1.107 -4.83887e-08Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1457 1.14847C90.169 0.526329 89.6618 0.0198994 89.0397 0.0198994L61.2388 0.0199006C60.6166 0.0199007 60.1117 0.524825 60.1117 1.14697L60.1117 28.9479C60.1117 29.57 60.6181 30.0772 61.2403 30.0539C76.9418 29.4746 89.5664 16.85 90.1457 1.14847Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.764 88.4265C120.429 89.3162 118.955 89.3162 118.62 88.4265C117.648 85.8433 116.056 82.3193 114.01 80.2733C111.964 78.2273 108.44 76.6352 105.857 75.6636C104.967 75.3285 104.967 73.8543 105.857 73.5192C108.44 72.5477 111.964 70.9555 114.01 68.9095C116.056 66.8635 117.648 63.3396 118.62 60.7571C118.955 59.8667 120.429 59.8667 120.764 60.7571C121.736 63.3396 123.328 66.8635 125.374 68.9095C127.42 70.9555 130.944 72.5477 133.527 73.5192C134.416 73.8543 134.416 75.3285 133.527 75.6636C130.944 76.6352 127.42 78.2273 125.374 80.2733C123.328 82.3193 121.736 85.8433 120.764 88.4265Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2672 60.1094C90.6447 60.1094 90.1379 59.6029 90.1609 58.9808C90.7406 43.2793 103.365 30.6547 119.067 30.0754C119.689 30.0521 120.195 30.5592 120.195 31.1814L120.195 58.9823C120.195 59.6045 119.691 60.1094 119.068 60.1094L91.2672 60.1094Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6017_2202)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 89.0917,
    transform: "matrix(1 0 0 -1 -0.00195312 89.0938)",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSetupRightCorner);
export default __webpack_public_path__ + "static/media/profile-setup-right-corner.3665e79d03df7ee60639e4995243689a.svg";
export { ForwardRef as ReactComponent };